import { Fragment, useState } from 'react';
import { useRouter } from "next/router";
import { getSession } from 'next-auth/client';
import { isMobileOnly } from 'react-device-detect';
import { listCountries, search, SEARCH_START } from '@app/utils';
import { Container, Section, Column, Title, ArticleSummary, Button, Bulletin, MobileInsertAd, LoadMoreSection, Seo } from '@app/components';


export const getServerSideProps = async (context) => {
  var { params, query } = context;
  let session = await getSession(context);
  const result = await listCountries([params.id])

  if (!result || result?.status !==200) {
    return {
      notFound: true,
    }
  }

  const {data} = result;
  const currCountry = data?.filter?.countryIds.find(obj => obj.selected === true)
  
  if(currCountry===undefined){
    return {
      notFound: true,
    };
  }else if(currCountry?.slug!==params?.country){
    return {
      redirect: {
        destination: `/country/${currCountry.slug}/${currCountry.key}`,
        permanent: false,
      }
    }
  }

  return {
    props: {
      params,
      country:currCountry,
      data: data,
      session: session
    }
  }
}

export default function Country({ params, data, country,session }) {
  const { items, paging } = data;

  const MainSection = () =>
    <Section title={<Title title={country?.text||''} />}>
      <>
        {items.map((item, i) =>
          <Fragment key={i}>
          {!(i === 0) && Number.isInteger(i / paging.rows * 2) ? <MobileInsertAd googleAd/> : ''}
          {isMobileOnly ? <ArticleSummary {...item} columnProps={{skipBorder: '8n'}} />
            : <ArticleSummary {...item} />}
          </Fragment>
        )}
      </>
    </Section>

  return <>
    <Seo.Countries data={data} country={country} />
    <Container center={<MainSection />} left={<div className='sm:tw-hidden 2xl:tw-block'><Bulletin /></div>} />
    {paging?.hasNext && 
      <LoadMoreSection key={`loadmore-country-${params.id}`} googleAd pagingData={paging} id={params.id}  func={`country`} />
    }
  </>
}